<template lang="pug">
#product-select
  v-autocomplete.customer-selector(
    v-model="select",
    solo,
    dense,
    hide-details,
    outlined,
    return-object,
    item-text="name",
    :items="items",
    :placeholder="$t('Placeholder.__ProductAndService')"
  )
    template(v-slot:append-item, v-if="insertTag")
      v-divider
      v-list-item.text-left(@click="addProductDialog = true")
        v-list-item-avatar
          v-icon add
        v-list-item-content
          v-list-item-title {{ $t('Products.__AddNewProduct') }}
  EditProductDialog(v-model="addProductDialog", :edit-type="1", :done-action="insertDoneAction", :category="category")
</template>
<script>
// test data
// import productsJSON from "@/test/data/products.json"
import EditProductDialog from "@/components/dialogs/EditProductDialog"

export default {
  components: { EditProductDialog },
  props: {
    value: {
      type: Object
    },
    category: {
      type: String,
      default: ""
    },
    insertTag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      search: null,
      items: [],
      select: [],
      products: [],
      addProductDialog: false
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    value(val) {
      this.select = val
    },
    select(val) {
      if (val) {
        this.$emit("input", val)
      }
    }
  },
  methods: {
    getProdcuts(productId) {
      this.$store
        .dispatch("products/getProducts", { pageSize: 999 })
        .then(
          function(response) {
            // this.items = this.products = response.data
            this.items = this.products = response.data.filter(
              function(product) {
                if (product.incomeAccountId != null && product.expenseAccountId != null) {
                  return true
                } else if (this.category == "buy" && product.expenseAccountId != null) {
                  return true
                } else if (this.category == "sell" && product.incomeAccountId != null) {
                  return true
                }
                return false
              }.bind(this)
            )
            if (productId) {
              var product = this.findProduct(productId)
              this.$emit("input", product)
            }
          }.bind(this)
        )
        .catch(function(error) {}.bind(this))
    },
    findProduct(id) {
      return this.products.find(element => element.id == id)
    },
    insertDoneAction(productId) {
      this.getProdcuts(productId)
    },
    querySelections(val) {
      // this.items = this.customers.filter(item => {
      //     return (
      //         (item.name || "")
      //             .toLowerCase()
      //             .indexOf((val || "").toLowerCase()) > -1 ||
      //         (item.code || "")
      //             .toLowerCase()
      //             .indexOf((val || "").toLowerCase()) > -1
      //     )
      // })
    }
  },
  mounted() {
    this.getProdcuts()
    this.select = this.value
  }
}
</script>
